import type { BackgroundJobDto } from "@/api/dtos";
import type { BackgroundJob, BackgroundJobStatus, BackgroundJobTrigger } from "@/api/background-job/_models/BackgroundJob";

export const toBackgroundJobFromBackgroundJobDto = (dto: BackgroundJobDto): BackgroundJob => {
  return {
    id: dto.id,
    kind: dto.kind,
    subject: dto.subject ?? undefined,
    status: dto.status as BackgroundJobStatus,
    input: dto.input,
    result: dto.result,
    error: dto.error ?? undefined,
    createdAt: dto.createdAt,
    startedAt: dto.startedAt ?? undefined,
    finishedAt: dto.finishedAt ?? undefined,
    trigger: dto.trigger as BackgroundJobTrigger,
    scheduleId: dto.scheduleId ?? undefined,
  };
};
